import React from "react"
import { gql, useQuery } from "@apollo/client"
import { Image, Spin } from "antd"

const GET_FILE_QUERY = gql`
  query getFile($id: uuid!) {
    files_by_pk(id: $id) {
      extension
      filename
      id
      mimetype
      s3_key
      size
    }
  }
`

const ImagePreview = ({ sourceUrl }) => {
  return <Image src={sourceUrl} />
}

const VideoPreview = ({ sourceUrl }) => {
  return (
    <video controls style={{ width: "100%" }}>
      <source src={sourceUrl} />
    </video>
  )
}

const AudioPreview = ({ sourceUrl }) => {
  return (
    <a href={sourceUrl} target="_blank">
      {sourceUrl}
    </a>
  )
}

const FilePreview = ({ sourceUrl }) => {
  return (
    <a href={sourceUrl} target="_blank">
      {sourceUrl}
    </a>
  )
}

const previewComponents = {
  image: ImagePreview,
  video: VideoPreview,
  audio: AudioPreview,
}

const RemoteFile = ({ fileId }) => {
  const { loading, error, data } = useQuery(GET_FILE_QUERY, {
    variables: { id: fileId },
  })

  if (loading) {
    return <Spin spinning />
  }

  if (error) {
    console.log("Loading file error.")
    console.error(error)
    return null
  }

  const file = data.files_by_pk

  if (!file) {
    return <h4>File cancellato.</h4>
  }

  const { filename, s3_key, mimetype } = file

  const PreviewComponent =
    previewComponents[mimetype.split("/")[0]] || FilePreview

  return (
    <>
      <h4>{filename}</h4>
      <PreviewComponent
        sourceUrl={`/.netlify/functions/get-download-url?key=${s3_key}`}
      />
    </>
  )
}

export default RemoteFile
